import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './AllImplants.module.css';
import AllImplantsList, { AllImplantsListRef } from './AllImplantsList';
import { useEffect, useState, useRef } from 'react';

const AllImplantsPage = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const [selectedCategory, setSelectedCategory] = useState<
        '' | 'types' | 'manufacturers' | 'bodyPlacements'
    >('');
    const [defaultVal, setDefaultVal] = useState('');
    const [availableLetters, setAvailableLetters] = useState<string[]>([]);
    const listRef = useRef<AllImplantsListRef>(null);

    useEffect(() => {
        const type = searchParams.get('type');
        const manufacturer = searchParams.get('manufacturer');
        const bodyPlacement = searchParams.get('bodyPlacement');
        if (type) {
            setSelectedCategory('types');
            setDefaultVal(type);
        } else if (manufacturer) {
            setSelectedCategory('manufacturers');
            setDefaultVal(manufacturer);
        } else if (bodyPlacement) {
            setSelectedCategory('bodyPlacements');
            setDefaultVal(bodyPlacement);
        }
    }, [searchParams]);

    return (
        <div className={styles.wrapper}>
            <h2>{t('allImplantsPage.title')}</h2>
            <div className={styles.tabs}>
                <div
                    onClick={() => setSelectedCategory('types')}
                    className={`${styles.tab} ${
                        selectedCategory === 'types' ? styles.selected : ''
                    }`}
                >
                    {t('allImplantsPage.tabs.types')}
                </div>
                <div
                    onClick={() => setSelectedCategory('manufacturers')}
                    className={`${styles.tab} ${
                        selectedCategory === 'manufacturers'
                            ? styles.selected
                            : ''
                    }`}
                >
                    {t('allImplantsPage.tabs.manufacturers')}
                </div>
                <div
                    onClick={() => setSelectedCategory('bodyPlacements')}
                    className={`${styles.tab} ${
                        selectedCategory === 'bodyPlacements'
                            ? styles.selected
                            : ''
                    }`}
                >
                    {t('allImplantsPage.tabs.bodyPlacements')}
                </div>
            </div>
            <div className={styles.alphabet}>
                {availableLetters.map((letter) => (
                    <div
                        key={letter}
                        className={styles.letter}
                        onClick={() => listRef.current?.scrollToLetter(letter)}
                    >
                        {letter}
                    </div>
                ))}
            </div>
            <div className={styles.lists}>
                <AllImplantsList
                    ref={listRef}
                    category={selectedCategory}
                    defaultValue={defaultVal}
                    onAvailableLettersChange={setAvailableLetters}
                />
            </div>
        </div>
    );
};

export default AllImplantsPage;
